// extracted by mini-css-extract-plugin
module.exports = {"overlay-mask":"bet-container_overlay-mask__he6tT","bet-container":"bet-container_bet-container__UB61P"};